import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router'
import { RequireAuth, Shell } from './components.tsx'
import LoginPage from './pages/LoginPage.tsx'
import RegisterPage from './pages/RegisterPage.tsx'
import HomeRedirect from './pages/HomeRedirect.tsx'
import ProfilePage from './pages/ProfilePage.tsx'
import ConsentPage from './pages/ConsentPage.tsx'
import GuardianConsentPage from './pages/GuardianConsentPage.tsx'
import InstructionsPage from './pages/InstructionsPage.tsx'
import FinishedPage from './pages/FinishedPage.tsx'

// The player is the heaviest screen and is only needed during a test, so it loads on demand.
const PlayerPage = lazy(() => import('./player/PlayerPage.tsx'))

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register/:institution/:campaign" element={<RegisterPage />} />
      <Route path="/consent/:token" element={<GuardianConsentPage />} />
      <Route element={<RequireAuth />}>
        <Route
          path="/test/:attemptId"
          element={<Suspense fallback={<p role="status" style={{ padding: 16 }}>Loading your test…</p>}><PlayerPage /></Suspense>}
        />
        <Route element={<Shell />}>
          <Route index element={<HomeRedirect />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/my-consent" element={<ConsentPage />} />
          <Route path="/instructions" element={<InstructionsPage />} />
          <Route path="/finished" element={<FinishedPage />} />
        </Route>
      </Route>
    </Routes>
  )
}
